import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Home from './pages/home';
import About from './pages/about';
import Service from './pages/service';

import Blog from './pages/blog';
import Contact from './pages/contactPage';
import Blogdetail from './pages/blog-details';
import BlogAdmin from './pages/blogadmin';
import Registration from './components/registration';
import Login from './components/login';
import { Analytics } from "@vercel/analytics/react"



function App() {
  return (
    <Router>
      <div className="App">

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogdetails" element={<Blogdetail />} />
          <Route path="/blogadmin" element={<BlogAdmin />} />
          <Route path="/blogdetails/:id" element={<Blogdetail />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          {/* Add more routes as needed */}
        </Routes>
        <Analytics />
      </div>
    </Router>
  );
}

export default App;